import React, { useState, useEffect } from "react";
import { useNavigate,useLocation } from "react-router-dom";
import AthleteLayout from "../common/AthleteLayout";
import { AthleteHeader } from "../common/AthleteHeader";
import { useAthleteAuthContext } from "../login/useAthleteAuthContext";
import API_URL from "../../api/API";

export const AthleteStaticStrengthWorkoutTemplateList = () => {
  const { athlete } = useAthleteAuthContext();
  const navigate = useNavigate();
  const location = useLocation();

  const [templates, setTemplates] = useState([]); // State for storing fetched phases
  const [isLoading, setIsLoading] = useState(false); // Loading state
  const [error, setError] = useState(null); // Error state
  const [selectedDate, setSelectedDate] = useState(new Date()); // State for selected date


  const fetchTemplatesData = async () => {
    try {
      setIsLoading(true); // Start loading
      console.log("server called");
      const response = await fetch(API_URL.GET_STATIC_STRENGTH_WORKOUT_TEMPLATES_FRONT_ATHLETE_PURCHASED + athlete.id, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${athlete.token}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        setError(errorData?.error || "Failed to fetch templates data");
        return;
      }

      const data = await response.json();
      console.log(data);
      setTemplates(data); // Assuming the response has a "phases" array
    } catch (err) {
      setError(err.message); // Set error message if there is a network issue
    } finally {
      setIsLoading(false); // Set loading to false once data fetching is completed
    }
  };

 // useEffect for checking location.state and fetching data if necessary
 useEffect(() => {
  console.log("Old State Data");
  console.log(location.state?.templates);

  // Check if templates exist in location.state
  if (location.state?.templates && location.state.templates.length > 0) {
    // If templates are in location.state, populate them
    setTemplates(location.state.templates);
    console.log("templates now populated....");
    console.log(templates);
  } else if (templates.length === 0) {
    // If templates are empty and not in state, fetch them from API
    fetchTemplatesData();
  }
}, [location.state, templates.length, athlete.token, athlete.id]);

  // Function to handle date change
  const changeDate = (days) => {
    setSelectedDate((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setDate(newDate.getDate() + days);
      return newDate;
    });
  };

  // Format the date for display
  const formatDate = (date) => {
    return date.toLocaleDateString("en-US", {
      weekday: "long",
      month: "short",
      day: "numeric",
    });
  };


  return (
    <AthleteLayout>
      <div className="bg-white">
        <AthleteHeader />
      </div>
      <div className="pb-3 flex flex-row justify-center items-center gap-10 bg-white">
        <ArrowL onClick={() => changeDate(-1)} />
        <p className="text-black text-xl font-normal">{formatDate(selectedDate)}</p>
        <ArrowG onClick={() => changeDate(1)} />
      </div>

      <div className="w-full max-w-2xl mx-auto h-full bg-black">
        <div className="text-white py-3 bg-black">

        <div className="flex justify-between gap-[68px] mb-4 px-5">        
            <button className="text-white border-b-2 border-white text-base pb-2 font-normal">
              Static Strength Templates
            </button>
          </div>
    
          {isLoading ? (
            <p className="text-white text-center">Loading templates...</p>
          ) : error ? (
            <div className="bg-red-100 text-red-500 p-3 rounded mb-4">{error}</div>
          ) : (
            <div className="space-y-[15px] overflow-hidden overflow-y-auto px-5">
              {templates &&
                templates.map((item) => (
                  <button
                    onClick={() => navigate('/athlete/static-strength-workout/' + item.template_id,{ state: { templates } })}
                    key={item.template_id}
                    className="w-full p-[14px] text-white font-normal border border-white/20 bg-transparent rounded-[15px] hover:bg-white/10 transition text-start"
                  >
                    {item.title} {/* Display label here */}
                  </button>
                ))}
            </div>
          )}
        </div>
      </div>
    </AthleteLayout>
  );
};

const ArrowG = ({ onClick }) => {
  return (
    <svg
      onClick={onClick}
      className="hover:opacity-50 cursor-pointer"
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
    >
      <path
        d="M1 13L7 7L0.999999 1"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const ArrowL = ({ onClick }) => {
  return (
    <svg
      onClick={onClick}
      className="hover:opacity-50 rotate-180 cursor-pointer"
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
    >
      <path
        d="M1 13L7 7L0.999999 1"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
